import React, { useState, useEffect } from "react";
import { Input, Label, Row, Col, Button } from "reactstrap";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

// Redux
import { connect } from "react-redux";

//Componentes
import CustomModal from "../../../components/modales/customModal";
import Loading from "../../../components/modales/loadingModal";

//Funciones
import { numeroALetras } from "../../../utils/numeroALetra/numeroALetra";

//API Calls
import { getDownloadURLAPI } from "../../../utils/FirebaseStorage/FirebaseStorage";
import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";
import { file } from "jszip";

const descargarContrato = functionsHttpsCallable("ape_exportarContrato");
// const descargarDocumentos = functionsHttpsCallable('ape_exportarDocumentosContractuales');
const getSitios = functionsHttpsCallable("ape_getSitiosContrato");
const getClausulasContrato = functionsHttpsCallable("ape_getClausulasContrato");
const getContratos = functionsHttpsCallable("ape_getContratos");
const getListaChequeo = functionsHttpsCallable("ape_getDataListaChequeo");
const actualizarAPE = functionsHttpsCallable("ape_actualizarSolicitudEmpleo");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

const ModalContratacion = (props) => {
  const getPeriodoPrueba = (tipoContrato, duracionContrato) => {
    if (tipoContrato === "OBRA O LABOR") return 60;
    else {
      const periodoPrueba = duracionContrato / 5;
      if (periodoPrueba > 60) return 60;
      else return Math.ceil(periodoPrueba);
    }
  };
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [loading, setLoading] = useState(false);
  const [clausulas, setClausulas] = useState({});
  const [opcionesLugarArea, setOpcionesLugarArea] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [areaEjecucion, setAreaEjecucion] = useState(undefined);
  const [campos, setCampos] = useState([]);
  const [campo, setCampo] = useState();
  const [cedula, setCedula] = useState(undefined);
  const [clausulaArr, setClausulaArr] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState();
  const [contratos, setContratos] = useState([]);
  const [correo, setCorreo] = useState(undefined);
  const [direccion, setDireccion] = useState(undefined);
  const [obraLabor, setObraeLabor] = useState(
    props.data.descripcionObraLabor ? props.data.descripcionObraLabor : ""
  );
  const [entidadEducativa, setEntidadEducativa] = useState(undefined); //Aprendizaje
  const [especialidad, setEspecialidad] = useState(undefined); //Aprendizaje
  const [fechaContratacion, setFechaContratacion] = useState(
    props.data.fechaContratacionLider
      ? new Date((props.data.fechaContratacionLider._seconds - 18000) * 1000)
      : new Date(Date.now())
  );
  const [fechaInicio, setFechaInicio] = useState(
    props.data.fechaContratacionLider
      ? new Date((props.data.fechaContratacionLider._seconds - 18000) * 1000)
      : new Date(Date.now())
  );
  // const [fechaInicio, setFechaInicio] = useState(new Date(Date.now()));
  const [fechaFinal, setFechaFinal] = useState(
    new Date(
      new Date(Date.now()).getTime() +
        (props.data.duracionContrato - 1) * 86400000
    )
  );
  const [fechaFinalEtapaProd, setFechaFinalEtapaProd] = useState(
    new Date(Date.now())
  ); //Aprendizaje
  const [fechaNacimiento, setFechaNacimiento] = useState(new Date(Date.now()));
  const [fileAlreadyExist, setFileAlreadyExist] = useState(false);
  const [intensidadHoraria, setIntensidadHoraria] = useState(undefined); //Aprendizaje
  const [lugarInicio, setLugarInicio] = useState(undefined);
  const [listaChequeo, setListaChequeo] = useState(undefined);
  const [listadoCorreosEnvio, setListadoCorreoEnvios] = useState("");
  const [listadoCorreosEnvioCopia, setListadoCorreoEnviosCopia] = useState("");
  const [lugarExpedicion, setLugarExpedicion] = useState(undefined);
  const [lugarNacimiento, setLugarNacimiento] = useState(undefined);
  const [newState, setNewState] = useState(props.currentState ?? undefined);
  const [nacionalidad, setNacionalidad] = useState("Colombiano");
  const [nombre, setNombre] = useState(undefined);
  const [observacion, setObservacion] = useState(
    props.observacion ?? "Escriba acá su observación"
  );
  const [periodoDePago, setPeriodoDePago] = useState(undefined);
  const [periodoDePrueba, setPeriodoDePrueba] = useState(
    getPeriodoPrueba(props.data.tipoContrato, props.data.duracionContrato)
  );
  const [pos, setPos] = useState(-1);
  const [sitioContratacion, setSitioContratacion] = useState(undefined);
  const [sitios, setSitios] = useState([]);
  const [sitio, setSitio] = useState();
  const [telCelular, setTelCelular] = useState(undefined);
  const [tipoDeAprendiz, setTipoDeAprendiz] = useState(undefined); //Aprendizaje
  const [tipoDeContrato, setTipoDeContrato] = useState(undefined);
  const [tipoDeDocumento, setTipoDeDocumento] = useState(undefined); //Aprendizaje
  const options = { year: "numeric", month: "long", day: "numeric" };

  useEffect(() => {
    async function getData() {
      setLoading(true);
      try {
        const fileList = [
          "EPS",
          "CAJA_DE_COMPENSACION",
          "FONDO_PENSIONES",
          "ARL",
          "CESANTIAS",
          "MANUAL_FUNCIONES_1",
        ];
        const manualUrl = await downloadFile(fileList);
        setAttachmentList([...manualUrl]);
        const sitiosData = await getSitios({
          cod_empr: userData.codigoEmpresa ?? 537,
        });
        const clausulasData = await getClausulasContrato({
          cod_empr: userData.codigoEmpresa ?? 537,
        });
        const contratosData = await getContratos({
          cod_empr: userData.codigoEmpresa ?? 537,
        });
        const listaChequeoData = await getListaChequeo({
          cod_empr: userData.codigoEmpresa ?? 537,
          ape: props.id,
        });
        setListaChequeo(listaChequeoData.data.data[0]);
        setContratos(contratosData.data.data);
        setClausulas({ ...clausulasData.data.data });
        setOpcionesLugarArea([...sitiosData.data.data]);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
    getData();
  }, []);

  useEffect(() => {
    setFechaFinal(
      new Date(
        fechaContratacion.getTime() +
          5 * 60 * 60 * 1000 +
          (props.data.duracionContrato - 1) * 86400000
      )
    );
  }, [fechaContratacion]);

  useEffect(() => {
    if (listaChequeo) {
      setCedula(listaChequeo.cedula);
      setCorreo(listaChequeo.correo);
      setNombre(listaChequeo.nombre);
      setTelCelular(listaChequeo.telefono);
      setDireccion(listaChequeo.direccion);
      setFechaNacimiento(
        new Date((listaChequeo.fechaNacimiento._seconds - 18000) * 1000)
      );
    }
  }, [listaChequeo]);

  useEffect(() => {
    getClientesUnicos();
  }, [opcionesLugarArea]);

  useEffect(() => {
    getCamposUnicos();
  }, [cliente]);

  useEffect(() => {
    getsitios();
  }, [campo]);

  useEffect(() => {
    updateSitios();
  }, [sitio]);

  const getClientesUnicos = () => {
    const clientes = [
      ...new Set(opcionesLugarArea.map((item) => item.cliente)),
    ];
    setClientes([...clientes]);
  };

  const getCamposUnicos = () => {
    const tempCampos = opcionesLugarArea.filter(
      (item) => item.cliente === cliente
    );
    const campos = [...new Set(tempCampos.map((item) => item.campo))]; // [ 'A', 'B']
    setCampos([...campos]);
  };

  const getsitios = () => {
    const tempSitios = opcionesLugarArea.filter((item) => item.campo === campo);
    setSitios([...tempSitios]);
  };
  const updateSitios = () => {
    if (sitio !== undefined) {
      setLugarInicio(sitio.lugar);
      setAreaEjecucion(sitio.area);
    }
  };

  const getClausulas = () => {
    let campo, cliente;
    if (props.data.campo.includes("-")) {
      cliente = props.data.campo.split("-")[0];
      campo = props.data.campo.split("-")[1];
    } else {
      cliente = props.data.campo;
      campo = props.data.campo;
    }
    let arrCliente = Array.from(cliente);
    let arrCampo = Array.from(campo);
    if (arrCliente[arrCliente.length - 1] === " ") {
      arrCliente.pop();
      cliente = arrCliente.join("");
    }
    if (arrCampo[0] === " ") {
      arrCampo.shift();
      campo = arrCampo.join("");
    }
    return Object.keys(clausulas).map((key, index) => {
      if (
        clausulas[key].uso === campo ||
        clausulas[key].uso === cliente ||
        clausulas[key].uso === "all"
      ) {
        return (
          <Col lg="6" md="12" xs="12">
            <Label check>
              <Input
                addon
                type="checkbox"
                id={`clausula_${index}`}
                onChange={(e) => handleAddClausula(e.target.checked, key)}
              />{" "}
              {clausulas[key].nombre}
            </Label>
          </Col>
        );
      }
    });
  };

  const downloadFile = async (filelist) => {
    const dataReturn = [];
    for (let fileName of filelist) {
      let tempArr = props.fileList.filter(
        (file) => file.fileName.split(".")[0] == fileName
      );
      if (tempArr.length > 0) {
        try {
          let downloadLink = await getDownloadURLAPI(
            `APEFiles/${props.id}`,
            tempArr[0].fileName
          );
          dataReturn.push({
            filename: tempArr[0].fileName,
            path: downloadLink,
          });
        } catch (e) {
          props.toastError(`El archivo ${tempArr[0].fileName} no existe`);
          console.log("error", e);
        }
      }
    }
    return dataReturn;
  };

  const getFinalValidation = () => {
    return (
      (tipoDeContrato !== undefined &&
        tipoDeContrato !== "" &&
        areaEjecucion !== undefined &&
        areaEjecucion !== "" &&
        cedula !== undefined &&
        cedula !== "" &&
        lugarExpedicion !== undefined &&
        lugarExpedicion !== "" &&
        correo !== undefined &&
        correo !== "" &&
        direccion !== undefined &&
        direccion !== "" &&
        fechaContratacion !== undefined &&
        fechaContratacion !== "" &&
        fechaInicio !== undefined &&
        fechaInicio !== "" &&
        fechaFinal !== undefined &&
        fechaFinal !== "" &&
        fechaNacimiento !== undefined &&
        fechaNacimiento !== "" &&
        lugarInicio !== undefined &&
        lugarInicio !== "" &&
        lugarNacimiento !== undefined &&
        lugarNacimiento !== "" &&
        nombre !== undefined &&
        nombre !== "" &&
        observacion !== undefined &&
        observacion !== "" &&
        periodoDePago !== undefined &&
        periodoDePago !== "" &&
        periodoDePrueba !== undefined &&
        periodoDePrueba !== "" &&
        pos !== undefined &&
        pos !== "" &&
        telCelular !== undefined &&
        telCelular !== "") ||
      (tipoDeContrato !== undefined &&
        tipoDeContrato !== "" &&
        tipoDeDocumento !== undefined &&
        tipoDeDocumento !== "" &&
        cedula !== undefined &&
        cedula !== "" &&
        lugarExpedicion !== undefined &&
        lugarExpedicion !== "" &&
        nombre !== undefined &&
        nombre !== "" &&
        correo !== undefined &&
        correo !== "" &&
        lugarNacimiento !== undefined &&
        lugarNacimiento !== "" &&
        direccion !== undefined &&
        direccion !== "" &&
        telCelular !== undefined &&
        telCelular !== "" &&
        tipoDeAprendiz !== undefined &&
        tipoDeAprendiz !== "" &&
        fechaInicio !== undefined &&
        fechaInicio !== "" &&
        fechaContratacion !== undefined &&
        fechaContratacion !== "" &&
        fechaFinalEtapaProd !== undefined &&
        fechaFinalEtapaProd !== "" &&
        intensidadHoraria !== undefined &&
        intensidadHoraria !== "" &&
        especialidad !== undefined &&
        especialidad !== "" &&
        entidadEducativa !== undefined &&
        entidadEducativa !== "")
    );
  };

  const handleUpdate = async () => {
    let body = {
      cod_soli: props.id,
      cod_empr: userData.codigoEmpresa,
      data: {
        ced_cand: cedula,
        nom_cand: nombre,
        cmp_stat: "SEGURIDAD_SOCIAL",
      },
    };
    let link;
    try {
      link = await handleDownload();
      props.toastSuccess("Contrato Generado");
    } catch (error) {
      console.log(error);
      props.toastError("Error en la actualización");
    }
    // let bodyCorreo = {
    //     enviarA: (listadoCorreosEnvio.length > 0 && listadoCorreosEnvio.includes('@')) ? listadoCorreosEnvio.split(',') : [props.data.flujo.emailPrimerAprobador],
    //     enviarACC: [props.data.flujo.emailPrimerAprobador, props.data.flujo.emailTercerAprobador, 'auxiliar.desarrollo@confipetrol.com', ],
    //     codigoAPE: props.id,
    //     nombre: nombre,
    //     cargo: props.data.codigoCargo,
    //     adjuntos: [
    //         {
    //             filename: `Contrato ${cedula}.pdf`,
    //             path: link
    //         },
    //         ...attachmentList
    //     ]
    // }
    // try {
    //     await envioCorreoLider(bodyCorreo)
    //     props.toastSuccess('Correo enviado');
    // }
    // catch (error) {
    //     console.log(error)
    //     props.toastError('Error envio del correo')
    // }
    try {
      await actualizarAPE(body);
      props.toastSuccess("Ape Actualizada");
      props.toggle();
    } catch (error) {
      console.log(error);
      props.toastError("Error en la actualización");
    }
  };

  const handleAddClausula = (checked, key) => {
    const tempArr = [...clausulaArr];
    if (checked) {
      const pos = tempArr.indexOf(key);
      if (pos < 0) tempArr.push(key);
    } else {
      const pos = tempArr.indexOf(key);
      if (pos >= 0) tempArr.splice(pos, 1);
    }
    setClausulaArr([...tempArr]);
  };

  const handleDownload = async () => {
    props.loadingModal();
    const body = {
      type: "DOC",
      contratoId: tipoDeContrato,
      cod_empr: userData.codigoEmpresa,
      clausulas: clausulaArr,
      data: {
        nombre: nombre ? nombre.toUpperCase() : "",
        cedula: cedula ?? undefined,
        lugarNacimiento: `${lugarNacimiento ?? ""}`,
        nacionalidad: `${nacionalidad ?? ""}`,
        soloLugarNacimiento: lugarNacimiento ?? "",
        fechaNacimiento: fechaNacimiento
          ? new Date(
              fechaNacimiento.getTime() + 5 * 60 * 60 * 1000
            ).toLocaleDateString("es-ES", options)
          : "",
        fechaCreacion: props.data.fechaCreacion
          ? new Date(
              new Date(props.data.fechaCreacion._seconds).getTime() +
                5 * 60 * 60 * 1000
            ).toLocaleDateString("es-ES", options)
          : "",
        // fechaCreacion: props.data.fechaCreacion ? new Date(props.data.fechaCreacion._seconds).toLocaleDateString('es-ES', options) : '',
        lugarExpedicion: lugarExpedicion ?? "",
        gerente: props.data.nombreTercerAprobador ?? "",
        cedulaContratacion: props.data.flujo.cedulaContratador ?? 0,
        contratacion: props.data.flujo.nombreContratador ?? "",
        direccion: direccion ?? "",
        telefono: telCelular ?? undefined,
        correo: correo ?? "",
        jefe: props.data.jefeInmediato ?? "",
        turno: props.data.turno ?? "",
        fechaContratacion: fechaContratacion
          ? new Date(
              fechaContratacion.getTime() + 5 * 60 * 60 * 1000
            ).toLocaleDateString("es-ES", options)
          : "",
        sitioContratacion: sitio.sitio ?? "",
        cargo: props.data.codigoCargo ?? "",
        campo: props.data.campo ?? "",
        fechaInicio: fechaInicio
          ? fechaInicio.toLocaleDateString("es-ES", options)
          : "",
        salario: props.data.salario
          ? `${numeroALetras(props.data.salario, {
              plural: "PESOS COLOMBIANOS",
              singular: "PESO COLOMBIANO",
              centPlural: "CENTAVOS",
              centSingular: "CENTAVO",
            })} - ($${parseInt(props.data.salario).toLocaleString()})`
          : "0.0",
        jornadaSuplementaria: props.data.jornadaSuplementaria
          ? !isNaN(props.data.jornadaSuplementaria)
            ? `${numeroALetras(props.data.jornadaSuplementaria, {
                plural: "PESOS COLOMBIANOS",
                singular: "PESO COLOMBIANOS",
                centPlural: "CENTAVOS",
                centSingular: "CENTAVO",
              })} ($ ${parseInt(
                props.data.jornadaSuplementaria
              ).toLocaleString()})`
            : "N/A"
          : "N/A",
        periodoPago: periodoDePago ?? "",
        terminoInicial: `${props.data.duracionContrato ?? "-"} DÍAS`,
        periodoPrueba: `${periodoDePrueba ?? "-"} DÍAS`,
        fechaVencimiento: fechaFinal
          ? fechaFinal.toLocaleDateString("es-ES", options)
          : "",
        lugarInicio: lugarInicio ?? "",
        areaLabores: areaEjecucion ?? "",
        tipoDeDocumento: tipoDeDocumento ?? "Cedula de Ciudadania",
        tipoDeAprendiz: tipoDeAprendiz ?? "",
        intensidadHoraria: intensidadHoraria ?? "",
        fechaFinalEtapaProd: fechaFinalEtapaProd
          ? fechaFinalEtapaProd.toLocaleDateString("es-ES", options)
          : "",
        especialidad: especialidad ?? props.data.especialidad,
        entidadEducativa: entidadEducativa ?? "",
        obraLabor: obraLabor ?? "",
        duracionContrato: props.data.duracionContrato
          ? parseInt(props.data.duracionContrato)
          : 0,
        auxilioAlimentacion: props.data.auxilioAlimentacion ?? 0,
        auxilioAlimentacionSIS: props.data.auxilioAlimentacionSIS ?? 0,
        auxilioLocalizacion: props.data.auxilioLocalizacion ?? 0,
        auxilioMovilizacion: props.data.auxilioMovilizacion ?? 0,
        bonificacionSIS: props.data.bonificacionSIS ?? 0,
        bonificacionCIS: props.data.bonificacionCIS ?? 0,
        bonificacionSISDiario: props.data.bonificacionSISDiario ?? 0,
        bonificacionCISDiario: props.data.bonificacionCISDiario ?? 0,
        primaElSauceMansovar: props.data.primaElSauceMansovar ?? 0,
        primaHabitacionalCIS: props.data.primaHabitacionalCIS ?? 0,
        primaAlimentacionYAlojamientoMasaro:
          props.data.primaAlimentacionYAlojamientoMasaro ?? 0,
        auxilioGaitanSIS: props.data.auxilioGaitanSIS ?? 0,
        auxilioConvencionalECP: props.data.auxilioConvencionalECP ?? 0,
        subsidioConvencionalHabitacion:
          props.data.subsidioConvencionalHabitacion ?? 0,
        auxilioTransporteConv: props.data.auxilioTransporteConv ?? 0,
        bonificacionBeneficioBienestar:
          props.data.bonificacionBeneficioBienestar ?? 0,
        auxCaminanteNoSalarial: props.data.auxCaminanteNoSalarial ?? 0,
        auxNoSalarialCasino: props.data.auxNoSalarialCasino ?? 0,
        auxProduccionYCampoSIS: props.data.auxProduccionYCampoSIS ?? 0,
        auxAlimentacionDiario: props.data.auxAlimentacionDiario ?? 0,
        auxMovilizacionDiario: props.data.auxMovilizacionDiario ?? 0,
        auxLocalizacionDiario: props.data.auxLocalizacionDiario ?? 0,
        auxLoncheSIS: props.data.auxLoncheSIS ?? 0,
        auxEspecialTransporteSIS: props.data.auxEspecialTransporteSIS ?? 0,
        auxEspecialAlimentacionSIS: props.data.auxEspecialAlimentacionSIS ?? 0,
        auxEspecialLejanias: props.data.auxEspecialLejanias ?? 0,
        auxNoSalarialBloqueMatambo: props.data.auxNoSalarialBloqueMatambo ?? 0,
        auxNoSalarialBloqueCampoRico:
          props.data.auxNoSalarialBloqueCampoRico ?? 0,
        auxViaticosTSA: props.data.auxViaticosTSA ?? 0,
        auxTrabajoRemotoUtipecSIS: props.data.auxTrabajoRemotoUtipecSIS ?? 0,
        auxNoSalarialBloqueMaranta: props.data.auxNoSalarialBloqueMaranta ?? 0,
        auxAlimentacionDiarioCIS: props.data.auxAlimentacionDiarioCIS ?? 0,
        auxViaticosEMO: props.data.auxViaticosEMO ?? 0,
        auxEconomicoObrasMetalMecanica:
          props.data.auxEconomicoObrasMetalMecanica ?? 0,
        auxTransporteDiarioSIS: props.data.auxTransporteDiarioSIS ?? 0,
        numeroContrato: props.data.numeroContrato ?? "--",
        observaciones: props.data.observaciones ?? "--",
      },
    };
    try {
      const downloadLink = await descargarContrato(body);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      props.loadingModal();
      props.toastSuccess("Contrato descargado!");
      return downloadLink.data.data;
    } catch (e) {
      console.log("error", e);
      props.toastError("Hubo un error");
      props.loadingModal();
    }
  };

  return (
    <React.Fragment>
      <CustomModal
        modal={props.modal}
        toggle={() => props.toggle()}
        buttonTitle={"Descargar"}
        onClick={() => {
          handleUpdate();
        }}
        buttonLoading={!getFinalValidation()}
        title={`Enviar Contrato`}
      >
        {loading ? (
          <Loading />
        ) : (
          <div>
            <Row>
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={contratos}
                  key={`key_TipoDeContrato`}
                  id={`select_TipoDeContrato`}
                  onChange={(event, newValue) =>
                    setTipoDeContrato(newValue.key)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Tipo de Contrato"}
                      margin="normal"
                    />
                  )}
                  getOptionLabel={(option) => option.nombre}
                  renderOption={(option) => (
                    <React.Fragment>{option.nombre}</React.Fragment>
                  )}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={[
                    "Cédula de Ciudadania",
                    "Tarjeta de Identidad",
                    "Cédula de Extranjería",
                    "Permiso De Protección Temporal",
                    "Permiso Especial de Trabajo",
                    "Pasaporte",
                  ]}
                  key={`key_TipoDoc`}
                  id={`select_TipoDoc`}
                  onChange={(event, newValue) => setTipoDeDocumento(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Tipo de Documento"}
                      margin="normal"
                    />
                  )}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={[
                    "Colombiano",
                    "Argentino",
                    "Boliviano",
                    "Chileno",
                    "Ecuatoriano",
                    "Mexicano",
                    "Paraguayo",
                    "Peruano",
                    "Uruguayo",
                    "Venezolano",
                  ]}
                  key={`key_TipoDoc`}
                  id={`select_TipoDoc`}
                  onChange={(event, newValue) => setNacionalidad(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Nacionalidad"}
                      margin="normal"
                    />
                  )}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">
                  Número de documento sin puntos o comas
                </Label>
                <Input
                  type="text"
                  name="text"
                  id="inputCedula"
                  defaultValue={cedula !== undefined ? cedula : ""}
                  value={cedula}
                  onChange={(e) => setCedula(e.target.value.toUpperCase())}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">Lugar de Expedición</Label>
                <Input
                  type="text"
                  name="text"
                  id="inputLugarExp"
                  defaultValue={
                    lugarExpedicion !== undefined ? lugarExpedicion : ""
                  }
                  value={lugarExpedicion}
                  onChange={(e) =>
                    setLugarExpedicion(e.target.value.toUpperCase())
                  }
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">Nombres y Apellidos</Label>
                <Input
                  type="text"
                  name="text"
                  id="inputNombre"
                  defaultValue={nombre !== undefined ? nombre : ""}
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value.toUpperCase())}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">Correo</Label>
                <Input
                  type="text"
                  name="text"
                  id="inputCorreo"
                  defaultValue={correo !== undefined ? correo : ""}
                  value={correo}
                  onChange={(e) => setCorreo(e.target.value.toUpperCase())}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">Lugar de Nacimiento</Label>
                <Input
                  type="text"
                  name="text"
                  id="inputLugarNacimiento"
                  defaultValue={
                    lugarNacimiento !== undefined ? lugarNacimiento : ""
                  }
                  value={lugarNacimiento}
                  onChange={(e) =>
                    setLugarNacimiento(e.target.value.toUpperCase())
                  }
                />
              </Col>
              <Col
                lg="6"
                md="12"
                xs="12"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                }}
              >
                <Label for="exampleSelect">Fecha de Nacimiento</Label>
                <Input
                  id="fechaNacimiento"
                  name="datetime"
                  value={
                    fechaNacimiento
                      ? fechaNacimiento.toISOString().split("T")[0]
                      : new Date(Date.now().getTime() + 86400000)
                          .toISOString()
                          .split("T")[0]
                  }
                  onChange={(e) => {
                    try {
                      if (!isNaN(new Date(e.target.value.toUpperCase())))
                        setFechaNacimiento(
                          new Date(e.target.value.toUpperCase())
                        );
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  type="date"
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">Direccion de residencia</Label>
                <Input
                  type="text"
                  name="text"
                  id="inputDireccion"
                  defaultValue={direccion !== undefined ? direccion : ""}
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value.toUpperCase())}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Label for="exampleSelect">Telefono móvil</Label>
                <Input
                  type="text"
                  name="text"
                  id="inputDireccion"
                  defaultValue={telCelular !== undefined ? telCelular : ""}
                  value={telCelular}
                  onChange={(e) => setTelCelular(e.target.value.toUpperCase())}
                />
              </Col>
              {tipoDeContrato === 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Autocomplete
                    required
                    margin="dense"
                    options={["SENA", "Universitario"]}
                    key={`key_TipoDoc`}
                    id={`select_TipoDoc`}
                    onChange={(event, newValue) => setTipoDeAprendiz(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={"Tipo de Aprendiz"}
                        margin="normal"
                      />
                    )}
                    getOptionLabel={(option) => option}
                    renderOption={(option) => (
                      <React.Fragment>{option}</React.Fragment>
                    )}
                  />
                </Col>
              ) : null}
              <Col
                lg="6"
                md="12"
                xs="12"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                }}
              >
                <Label for="exampleSelect">Fecha de Contratación</Label>
                <Input
                  id="fechaContratacion"
                  name="datetime"
                  value={
                    fechaContratacion
                      ? fechaContratacion.toISOString().split("T")[0]
                      : new Date(Date.now().getTime() + 86400000)
                          .toISOString()
                          .split("T")[0]
                  }
                  onChange={(e) => {
                    try {
                      if (!isNaN(new Date(e.target.value.toUpperCase())))
                        setFechaContratacion(
                          new Date(e.target.value.toUpperCase())
                        );
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  type="date"
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={clientes}
                  key={`key_TipoDeContrato`}
                  id={`select_TipoDeContrato`}
                  onChange={(event, newValue) => setCliente(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label={"Cliente"} margin="normal" />
                  )}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={campos}
                  key={`key_TipoDeContrato`}
                  id={`select_TipoDeContrato`}
                  onChange={(event, newValue) => setCampo(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label={"Campo"} margin="normal" />
                  )}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                />
              </Col>
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={sitios}
                  key={`key_TipoDeContrato`}
                  id={`select_TipoDeContrato`}
                  onChange={(event, newValue) => setSitio({ ...newValue })}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Sitio de Contratación"}
                      margin="normal"
                    />
                  )}
                  getOptionLabel={(option) => option.sitio}
                  renderOption={(option) => (
                    <React.Fragment>{option.sitio}</React.Fragment>
                  )}
                />
              </Col>
              {tipoDeContrato !== 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Cargo</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputCargo"
                    defaultValue={props.data.codigoCargo}
                    readOnly
                  />
                </Col>
              ) : null}
              <Col
                lg="6"
                md="12"
                xs="12"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                }}
              >
                <Label for="exampleSelect">Fecha de Inicio</Label>
                <Input
                  id="fechaInicio"
                  name="datetime"
                  value={
                    fechaInicio
                      ? fechaInicio.toISOString().split("T")[0]
                      : new Date(Date.now().getTime() + 86400000)
                          .toISOString()
                          .split("T")[0]
                  }
                  onChange={(e) =>
                    setFechaInicio(new Date(e.target.value.toUpperCase()))
                  }
                  type="date"
                />
              </Col>
              {tipoDeContrato === 8 ? (
                <Col
                  lg="6"
                  md="12"
                  xs="12"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                  }}
                >
                  <Label for="exampleSelect">
                    Fecha de Fin Etapa Productiva
                  </Label>
                  <Input
                    id="fechaFinalEtapaProd"
                    name="datetime"
                    value={
                      fechaFinalEtapaProd
                        ? fechaFinalEtapaProd.toISOString().split("T")[0]
                        : new Date(Date.now().getTime() + 86400000)
                            .toISOString()
                            .split("T")[0]
                    }
                    onChange={(e) =>
                      setFechaFinalEtapaProd(
                        new Date(e.target.value.toUpperCase())
                      )
                    }
                    type="date"
                  />
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Salario</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputSalario"
                    defaultValue={
                      props.data.salario
                        ? parseInt(props.data.salario).toLocaleString()
                        : "$ 0"
                    }
                    readOnly
                  />
                </Col>
              ) : null}
              <Col lg="6" md="12" xs="12">
                <Autocomplete
                  required
                  margin="dense"
                  options={["Mensual", "Quincenal", "Catorcenal", "Decadal"]}
                  key={`key_PeriodoPago`}
                  id={`select_PeriodoPago`}
                  onChange={(event, newValue) => setPeriodoDePago(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Periodo de Pago"}
                      margin="normal"
                    />
                  )}
                  getOptionLabel={(option) => option}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                />
              </Col>
              {[0, 1, 6, 7].includes(tipoDeContrato) ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Termino Inicial</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputTerminoInicial"
                    defaultValue={`${props.data.duracionContrato} días`}
                    readOnly
                  />
                </Col>
              ) : null}
              {[2, 3].includes(tipoDeContrato) ? (
                <Col lg="12" md="12" xs="12">
                  <Label for="exampleSelect">Obra Labor</Label>
                  <Input
                    type="textarea"
                    name="text"
                    id="inputObraLabor"
                    disabled={true}
                    defaultValue={obraLabor !== undefined ? obraLabor : ""}
                    value={obraLabor}
                    onChange={(e) =>
                      setObraeLabor(e.target.value.toUpperCase())
                    }
                  />
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Fecha Final</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputFechaFinal"
                    value={fechaFinal.toLocaleDateString("en-GB")}
                    readOnly
                  />
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Periodo de prueba</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputPeriodoDePrueba"
                    defaultValue={periodoDePrueba}
                    readOnly
                  />
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">
                    Lugar de inicio de actividades
                  </Label>
                  <Input
                    type="textarea"
                    name="text"
                    id="inputLugarInicio"
                    defaultValue={sitio !== undefined ? sitio.lugar : ""}
                    value={lugarInicio}
                    onChange={(e) =>
                      setLugarInicio(e.target.value.toUpperCase().toUpperCase())
                    }
                  />
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">
                    Área de ejecución de Labores
                  </Label>
                  <Input
                    type="textarea"
                    name="text"
                    id="inputArea"
                    defaultValue={sitio !== undefined ? sitio.area : ""}
                    value={areaEjecucion}
                    onChange={(e) =>
                      setAreaEjecucion(
                        e.target.value.toUpperCase().toUpperCase()
                      )
                    }
                  />
                </Col>
              ) : null}
              {tipoDeContrato === 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Intensidad Horaria</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputIntensidad"
                    defaultValue={
                      intensidadHoraria !== undefined ? intensidadHoraria : ""
                    }
                    value={intensidadHoraria}
                    onChange={(e) =>
                      setIntensidadHoraria(e.target.value.toUpperCase())
                    }
                  />
                </Col>
              ) : null}
              {tipoDeContrato === 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Entidad Educativa</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputEntidad"
                    defaultValue={
                      entidadEducativa !== undefined ? entidadEducativa : ""
                    }
                    value={entidadEducativa}
                    onChange={(e) =>
                      setEntidadEducativa(e.target.value.toUpperCase())
                    }
                  />
                </Col>
              ) : null}
              {tipoDeContrato === 8 ? (
                <Col lg="6" md="12" xs="12">
                  <Label for="exampleSelect">Especialidad</Label>
                  <Input
                    type="text"
                    name="text"
                    id="inputEspecialidad"
                    defaultValue={
                      especialidad !== undefined ? especialidad : ""
                    }
                    value={especialidad}
                    onChange={(e) =>
                      setEspecialidad(e.target.value.toUpperCase())
                    }
                  />
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? (
                <Col lg="12" md="12" xs="12">
                  <Label for="exampleSelect">Clausulas</Label>
                </Col>
              ) : null}
              {tipoDeContrato !== 8 ? getClausulas() : null}
            </Row>
          </div>
        )}
      </CustomModal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ModalContratacion);
